// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__hLOBw","productName":"Table_productName__KL3LD"};